import React, { useState } from "react";
import { ICreateExpenseData } from "../../../@types";
import { Tooltip } from "../../../assets/icons/Tooltip";
import { EXPENSE_CATEGORY, PAYMENT_PROVIDER_LIST } from "../../../constants";
import { DropdownComponent } from "../../core/Forms";
import { useTranslation } from "react-i18next";
import TooltipDropdown from "../../common/tooltipDropdown";

interface ExpenseDetailProps {
  formData: ICreateExpenseData;
  validationResults: ICreateExpenseData;
  handleDropDownChange: (name: string, value: string) => void;
  setValidationResults: React.Dispatch<
    React.SetStateAction<ICreateExpenseData>
  >;
  toolTipText?: string;
  toolTipText2?: string;
}

const ExpenseCategory: React.FC<ExpenseDetailProps> = ({
  handleDropDownChange,
  validationResults,
  formData,
  setValidationResults,
  toolTipText,
  toolTipText2,
}) => {
  const { t } = useTranslation("expenses");
  const dropDownCategory = EXPENSE_CATEGORY;
  const dropDownPaymentMethod = PAYMENT_PROVIDER_LIST;

  const [isHovered, setIsHovered] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const handleMouseEnter2 = () => {
    setIsHovered2(true);
  };

  const handleMouseLeave2 = () => {
    setIsHovered2(false);
  };

  return (
    <>
      {/* Desktop */}
      <div className="hidden w-full mt-[1.4em] lg:block md:block  lg:mr-[2.2em]">
        <div className="mt-1 flex flex-col justify-end w-full items-end gap-4 text-right  lg:mr-[2em] ">
          <div className=" w-full">
            <div className="flex items-center gap-2">
              <label
                htmlFor="customer"
                className="text-[12px] md:text-[14px] cursor-pointer"
                style={{ whiteSpace: "nowrap" }}
              >
                {t("budget.paymentMethod")}
              </label>
              {toolTipText && (
                <div
                  className="relative"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <TooltipDropdown
                    toolTipText={toolTipText}
                    isHovered={isHovered}
                  />
                </div>
              )}
            </div>
            <div className="w-full relative cursor-pointer mt-1">
              <DropdownComponent
                name={"paymentMethod"}
                options={dropDownPaymentMethod}
                placeholder="Payment method"
                selectedValue={formData.paymentMethod}
                onChange={handleDropDownChange}
                dropdownClassName=" rounded placeholder:text-[10px] text-[16px] capitalize cursor-pointer !focus:outline-none outline-none !ring-0 !focus:ring-0"
                iconClassName="mr-0 xl:mt-[0.1em] biglg:mt-[-0.2em]"
              />
              {validationResults.paymentMethod && (
                <span
                  className=" absolute text-red-500 text-[11px] lg:mr-[5em] "
                  style={{
                    top: "100%",
                    left: "0",
                    whiteSpace: "nowrap",
                    lineHeight: "1.2",
                  }}
                >
                  {validationResults.paymentMethod}
                </span>
              )}
            </div>
          </div>
          <div className="w-full">
            <div className="flex items-center gap-2">
              <label
                htmlFor="customer"
                className="text-[12px] lg:text-[14px] cursor-pointer"
                style={{ whiteSpace: "nowrap" }}
              >
                {t("budget.category")}
              </label>
              {toolTipText2 && (
                <div
                  className="relative"
                  onMouseEnter={handleMouseEnter2}
                  onMouseLeave={handleMouseLeave2}
                >
                  <TooltipDropdown
                    toolTipText={toolTipText2}
                    isHovered={isHovered2}
                  />
                </div>
              )}
            </div>
            <div className="w-full relative cursor-pointer mt-1">
              <DropdownComponent
                name="category"
                options={dropDownCategory}
                value={formData.category}
                placeholder="Search for industry"
                selectedValue={formData.category}
                onChange={handleDropDownChange}
                dropdownClassName="w-full placeholder:text-[10px] text-[16px] !text-left !bg-white cursor-pointer"
                iconClassName="mr-1 xl:mt-[0.1em] biglg:mt-[-0.2em]"
                enableSearch={true}
              />

              {validationResults.category && (
                <span
                  className=" absolute text-red-500 text-[11px] lg:mr-[5em]"
                  style={{
                    top: "100%",
                    left: "0",
                    whiteSpace: "nowrap",
                    lineHeight: "1.2",
                  }}
                >
                  {validationResults.category}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="lg:hidden md:hidden pt-2">
        <div className="mt-1 flex flex-col md:flex-row justify-between  gap-4 text-left ">
          <div className="">
            <label
              htmlFor="customer"
              className=" inline-flex text-[14px] lg:text-[14px] mb-2 lg:mr-[4em]  cursor-pointer"
              style={{ whiteSpace: "nowrap" }}
            >
              Payment Method
            </label>
            <div className="md:w-[118px]">
              <DropdownComponent
                name={"paymentMethod"}
                options={dropDownPaymentMethod}
                placeholder="Select method"
                selectedValue={formData.paymentMethod}
                onChange={handleDropDownChange}
                dropdownClassName="w-[118px]  rounded placeholder:text-[10px] pl-2 text-[16px] !capitalize  cursor-pointer "
                iconClassName="md:mr-3 md:mt-[-0.5em] mt-[0.5em]"
              />
              <div className="xl:mt-[em]">
                {validationResults.paymentMethod && (
                  <span
                    className="text-red-500"
                    style={{
                      whiteSpace: "nowrap",
                      padding: "0",
                      lineHeight: "1.2",
                    }}
                  >
                    {validationResults.paymentMethod}
                  </span>
                )}
              </div>
            </div>
          </div>
          <hr className="lg:mt-[3em] md:hidden border-[#EAECF0] border-[0.5px] lg:mx-6 pr-0 mt-[1em]" />
          <div className="mt-1 ">
            <label
              htmlFor="customer"
              className=" inline-flex gap-[em] text-[14px] mb-2 md:w-[118px] ml-[0.5em]"
              style={{ whiteSpace: "nowrap" }}
            >
              Category
            </label>
            <div className="">
              <DropdownComponent
                name="category"
                options={dropDownCategory}
                value={formData.category}
                placeholder="Search for category"
                selectedValue={formData.category}
                onChange={handleDropDownChange}
                dropdownClassName="w-[118px]   placeholder:text-[10px] text-[16px] pl-2 !capitalize text-[14px] "
                iconClassName="md:mr-3 md:mt-[-0.4em] mt-[0.4em]"
                enableSearch={true}
              />
              <div className="">
                {validationResults.category && (
                  <span
                    className="text-red-500"
                    style={{
                      whiteSpace: "nowrap",
                      padding: "0",
                      lineHeight: "1.2",
                    }}
                  >
                    {validationResults.category}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpenseCategory;
